import { Component, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import {distinctUntilChanged, shareReplay, takeUntil } from 'rxjs/operators';
import { FeatureFlagService, MaintenanceBannerConfig } from '../../core/services/feature-flag.service';

@Component({
  selector: 'app-maintenance-banner',
  templateUrl: './maintenance-banner.component.html',
  styleUrl: './maintenance-banner.component.css',
})
export class MaintenanceBannerComponent implements OnInit, OnDestroy {
  bannerConfig$: Observable<MaintenanceBannerConfig>;

  private destroy$ = new Subject<void>();

  constructor(
    private featureFlagService: FeatureFlagService,
    private renderer: Renderer2,
  ) {
    this.bannerConfig$ = this.featureFlagService.getMaintenanceBannerConfig$().pipe(
      distinctUntilChanged((a, b) => a.enabled === b.enabled && a.message === b.message && a.type === b.type),
      shareReplay(1),
    );
  }

  ngOnInit(): void {
    this.bannerConfig$.pipe(takeUntil(this.destroy$)).subscribe((config) => {
      if (config.enabled) {
        this.renderer.addClass(document.body, 'maintenance-banner-active');
      } else {
        this.renderer.removeClass(document.body, 'maintenance-banner-active');
      }
    });
  }

  ngOnDestroy(): void {
    this.renderer.removeClass(document.body, 'maintenance-banner-active');
    this.destroy$.next();
    this.destroy$.complete();
  }
}
